import React from 'react';
import {FontWeightMedium} from 'src/res/FontWeight';
import {logDebug} from "../../utils/AppLog";
import {locString} from "../commons/ViewHelper";
import View from "../commons/View";
import ImageBackground from "../commons/ImageBackground";
import AppImage from "../commons/AppImage";
import CircularProgress from "@material-ui/core/CircularProgress";
import AppUtils, {flattenTo2DArray} from "../../utils/AppUtils";
import {
  GAME_CRUSH_AUDIO,
  GAME_NEUTRAL_AUDIO,
  GAME_TIMER_AUDIO,
  GAME_WIN_AUDIO
} from "../../utils/GameAudioPlayer";
import AppText from "../commons/AppText";
import FocusHelperView from "../commons/FocusHelperView";
import GameAudio from "../commons/GameAudio";
import ActivityHelper from "../../utils/ActivityHelper";
import TouchableOpacity from "../commons/TouchableOpacity";


export default class GamePuzzleSlideView extends React.PureComponent {

  constructor(props) {
    super(props);
    this.gameLastTime = 0;
    this.endGameProcessStartTime = 0;
    this.puzzlePieces = null;

    this.state = this.getDefaultState();
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
      this.timeoutRef = null;
    }
    this.stopGameTimer();
  }

  onDidFocus() {
    if (this.wasTimerRunning) {
      this.startGameTimer();
    }
  }

  onDidBlur() {
    if (this.intervalHandler) {
      this.wasTimerRunning = true;
      this.stopGameTimer();
    }
  }

  simulatePlay() {
    if (!this.state.isGameOver && this.refGrid) {
      const moves = this.refGrid.getMoves();
      this.swipeNext(moves, moves.length - 1, 500);
    }
  }

  swipeNext(moves, moveCounter) {
    this.timeoutRef = setTimeout(() => {
      if (!this.state.isGameOver && this.refGrid) {
        this.refGrid.onCardChange(moves[moveCounter].movedTile);

        if (moveCounter > 0) {
          this.swipeNext(moves, moveCounter - 1);
        }
      }
    }, 500);
  }

  resetForPreview(items) {
    this.reset(items);
  }

  reset(items) {
    this.stopGameTimer(false);
    setTimeout(() => {
      const currentTime = new Date().getTime();
      const idleTime = 2 * 1000;
      const resetAfter = Math.max(0, idleTime - (currentTime - this.endGameProcessStartTime));

      setTimeout(() => {
        this.endGameProcessStartTime = 0;
        this.puzzlePieces = null;
        this.setState(this.getDefaultState());
        if (this.refGrid) {
          this.refGrid.reset();
        }
      }, resetAfter);
    }, 100);
  }

  getDefaultState() {
    return {
      isGameOver: false,
      isWin: false,
      isLose: false,
      gameTimer: 0,
      movesCount: 0,
    };
  }

  playGamePlayAudio() {
    if (this.gamePlayAudioId) {
      this.gamePlayAudioId.play();
    }
  }

  playGameTimerAudio() {
    if (this.gameTimerAudioId) {
      this.gameTimerAudioId.play();
    }
  }

  stopGameTimerAudio() {
    if (this.gameTimerAudioId) {
      this.gameTimerAudioId.pause();
    }
  }

  render() {
    const uiConfigs = this.props.uiConfigs;
    const sizeFactor = uiConfigs.sizeFactor;
    const isDisabled = this.props.disabled;
    const rows = this.props.rows;
    const columns = this.props.columns;
    const isRTL = !this.props.isLTR;

    const cardSize = this.getCardSize();
    const cardSpacing = this.getCardSpacing();
    const gameViewWidth = Math.ceil((cardSize + cardSpacing) * columns + 1);
    const gameViewHeight = Math.ceil((cardSize + cardSpacing) * rows + 1);
    const gameBgMargin = uiConfigs.gameBgMarginStartEnd * sizeFactor;
    const gameBgMarginTop = uiConfigs.gameBgMarginTop * sizeFactor;
    const gameBgMarginBottom = uiConfigs.gameBgMarginBottom * sizeFactor;

    const gameTimeLeft = ActivityHelper.getGameTimeText(this.props.gameTime - this.state.gameTimer);
    const showMovesCount = this.props.flipsNeeded && (this.props.flipsNeeded < 10000 || this.props.flipsNeeded - this.state.movesCount < 10000);
    let flipsCountText = null;
    if (showMovesCount) {
      flipsCountText = Math.max(0, this.props.flipsNeeded - this.state.movesCount);
    }
    return (
      <View style={{alignItems: 'center'}}>
        <FocusHelperView
          onNavigationDidFocus={() => this.onDidFocus()}
          onNavigationDidBlur={() => this.onDidBlur()}
          onAppDidFocus={() => this.onDidFocus()}
          onAppDidBlur={() => this.onDidBlur()}
        />
        {!this.props.disableAudio ?
          <div>
            <GameAudio ref={(ref) => this.gamePlayAudioId = ref} source={this.props.gamePlayAudioUrl || GAME_CRUSH_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gameTimerAudioId = ref} source={GAME_TIMER_AUDIO} autoPlay={false} loop={true} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gamePlayAudioIdNeutral = ref} source={GAME_NEUTRAL_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gamePlayAudioIdWin = ref} source={GAME_WIN_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
          </div>
          : null
        }
        <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginBottom: -4}}>
          {showMovesCount || this.props.gameTime ?
            <View style={{marginLeft: isRTL ? 20 * sizeFactor : 0, marginRight: isRTL ? 0 : 20 * sizeFactor, marginBottom: 8}}>
              {showMovesCount ?
                <ImageBackground source={uiConfigs.tryCounterImage} resizeMode="fill" style={{height: 44 * sizeFactor, width: 130 * sizeFactor, display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 8, paddingTop: 4}} >
                  <AppText fontSizeN={uiConfigs.fontSize} style={{align: 'center',position: 'relative', fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, flex: 1, marginLeft: 48 * sizeFactor, marginRight: 4 * sizeFactor, marginTop: 2 * sizeFactor, justifyContent: 'center'}}>
                    {flipsCountText}
                  </AppText>
                </ImageBackground>
                : null
              }
              {this.props.gameTime ?
                <ImageBackground source={uiConfigs.timerImage} resizeMode="fill" style={{height: 44 * sizeFactor, width: 130 * sizeFactor, display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: 4}} >
                  <AppText fontSizeN={uiConfigs.fontSize} style={{align: 'center',position: 'relative', fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, flex: 1, marginLeft: 48 * sizeFactor, marginRight: 4 * sizeFactor, marginTop: 4 * sizeFactor, justifyContent: 'center'}}>
                    {gameTimeLeft}
                  </AppText>
                </ImageBackground>
                : null
              }
            </View>
            : null
          }
          <ImageBackground source={uiConfigs.gameMediaImage} resizeMode="fill" style={{height: 96 * sizeFactor, width: 110 * sizeFactor, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 8 * sizeFactor, paddingBottom: 12 * sizeFactor, paddingTop: 20 * sizeFactor}}>
            <TouchableOpacity onClick={this.onPuzzleImageClicked}>
              <AppImage imageUrl={this.props.puzzleImage} style={{position: 'relative', width: 80 * sizeFactor, height: 80 * sizeFactor, borderRadius: 8 * sizeFactor, borderWidth: 1, borderColor: 'rgb(99,99,99)'}}/>
            </TouchableOpacity>
          </ImageBackground>
        </View>
        <ImageBackground source={uiConfigs.gameBgImage} resizeMode="fill" style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', height: gameViewHeight + gameBgMarginTop + gameBgMarginBottom, width: gameViewWidth + 2 * gameBgMargin, padding: gameBgMargin - 2, paddingTop: gameBgMarginTop - 1, paddingBottom: gameBgMarginBottom - 1, overflow: 'hidden', opacity: isDisabled ? 0.8 : 1}}>
          <Grid
            ref={this.handleRefGrid}
            simulation={this.props.simulation}
            items={this.items}
            rows={this.props.rows}
            columns={this.props.columns}
            size={cardSize}
            imageUrl={this.props.puzzleImage}
            won={this.props.won}
            countPerPiece={1}
            onChange={this.onChange}
          />
          {this.state.isGameOver || isDisabled
            ? <View style={{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, zIndex: 1}} />
            : null
          }
          {!this.props.simulation && (this.state.isWin || this.state.isLose) ?
            <View style={{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, alignItems: 'center', justifyContent: 'center'}}>
              {/*<View>*/}
              {/*  <View style={{padding: 8, paddingLeft: 16, paddingRight: 16, marginBottom: 4, backgroundColor: AppUtils.colorWithAlpha(uiConfigs.messageBgColor, 0.9), borderRadius: 20}}>*/}
              {/*    <AppText fontSizeN={uiConfigs.fontSize} variant={'h6'} style={{color: uiConfigs.titleColor, fontWeight: FontWeightMedium}}>*/}
              {/*      {this.state.isWin ? locString('youWon') : locString('gameEnded')}*/}
              {/*    </AppText>*/}
              {/*  </View>*/}
                <CircularProgress size={uiConfigs.fontSize * 2} style={{color: uiConfigs.messageBgColor}}/>
              {/*</View>*/}
            </View>
            : null
          }
        </ImageBackground>
      </View>
    );
  }

  handleRefGrid = (ref) => {
    this.refGrid = ref;
  }

  onPuzzleImageClicked = () => {
    this.props.onImageClicked(this.props.puzzleImage);
  };

  onChange = (keys) => {
    if (this.props.noActionMode) {
      this.props.onActionClickedInNoActionMode();
      return;
    }
    if (this.state.movesCount === 0) {
      if (this.props.onStart) {
        this.props.onStart();
      }
    }

    this.startGameTimer();
    const movesCount = this.state.movesCount + 1;
    const isGameOver = this.processGameResult(keys, movesCount, this.state.gameTimer);
    if (isGameOver) {
      this.stopGameTimer();
    }
    this.puzzlePieces = keys;
    this.setState({
      movesCount: movesCount,
      isGameOver: isGameOver
    });
    this.playGamePlayAudio();
  };

  startGameTimer() {
    if (this.props.gameTime && !this.intervalHandler) {
      this.gameLastTime = new Date().getTime();
      this.intervalHandler = setInterval(() => {
        this.updateTimeElapsed();
      }, 500);
      this.playGameTimerAudio();
    }
  }

  stopGameTimer() {
    if (this.intervalHandler) {
      this.stopGameTimerAudio();
      clearInterval(this.intervalHandler);
      this.intervalHandler = null;
      this.updateTimeElapsed();
    }
  }

  updateTimeElapsed() {
    let isGameOver = false;

    const currentTime = new Date().getTime();
    const timeDiff = currentTime - this.gameLastTime;
    this.gameLastTime = currentTime;
    const timeElapsed = Math.min(this.state.gameTimer + timeDiff, this.props.gameTime);
    const timeOver = timeElapsed >= this.props.gameTime;
    if (timeOver) {
      this.stopGameTimer();
      isGameOver = this.processGameResult(this.puzzlePieces, this.state.movesCount, timeElapsed);
    }
    this.setState({
      gameTimer: timeElapsed,
      isGameOver: isGameOver
    });
  }

  isGameWin(puzzlePieces) {
    for (let i = 0; i < this.props.rows * this.props.columns; i++) {
      if (puzzlePieces[i] !== i) {
        return false;
      }
    }
    return true;
  }

  isPlayEnded(movesCount, gameTimer) {
    if (this.props.flipsNeeded && this.props.flipsNeeded <= movesCount) {
      return true;
    }
    return this.props.gameTime && this.props.gameTime <= gameTimer;
  }

  processGameResult(puzzlePieces, movesCount, gameTimer) {
    if (this.isGameWin(puzzlePieces)) {
      setTimeout(() => {
        this.processGameEnd(true);
        this.setState({isWin: true, isLose: false});
      }, 400);
      return true;
    } else if (this.isPlayEnded(movesCount, gameTimer)) {
      setTimeout(() => {
        this.processGameEnd(false);
        this.setState({isWin: false, isLose: true});
      }, 200);
      return true;
    }
    return false;
  }

  processGameEnd(isWin) {
    if (!this.endGameProcessStartTime) {
      this.endGameProcessStartTime = new Date().getTime();

      // Vibration.vibrate(200);
      if (isWin) {
        if (this.gamePlayAudioIdWin) {
          this.gamePlayAudioIdWin.play();
        }
      } else {
        if (this.gamePlayAudioIdNeutral) {
          this.gamePlayAudioIdNeutral.play();
        }
      }

      // const endGameValue = JSON.stringify({
      //   isWin: isWin,
      //   indexes: this.puzzlePieces,
      //   timer: this.state.gameTimer
      // });
      if (this.props.onEnd) {
        this.props.onEnd({
          isWin: isWin,
          indexes: this.puzzlePieces,
          timer: this.state.gameTimer
        });
      }
    }
  }

  getCardSize() {
    const uiConfigs = this.props.uiConfigs;
    const sizeFactor = uiConfigs.sizeFactor;
    const rows = this.props.rows;
    const columns = this.props.columns;

    const cardSpacing = this.getCardSpacing();
    const otherUiHeight = 160 * sizeFactor;
    const borderWidth = 2 * uiConfigs.gameBgMarginStartEnd * sizeFactor;
    const borderHeight = (uiConfigs.gameBgMarginTop + uiConfigs.gameBgMarginBottom) * sizeFactor;
    const possibleWidth = (this.props.contentWidth - borderWidth - (columns - 1) * cardSpacing) / columns; // viewMargin, borderWidth, margin to each card
    const possibleHeight = (this.props.contentHeight - otherUiHeight - borderHeight - (rows - 1) * cardSpacing) / rows; // viewMargin, borderWidth, margin to each card
    const possibleSize = Math.min(possibleWidth, possibleHeight);
    const cardSize = Math.floor(Math.min(200, possibleSize));
    return cardSize;
  }

  getCardSpacing() {
    return 0;
  }
}

class Grid extends React.Component {

  constructor(props) {
    super(props);

    this.moves = null;
    this.state = {
      tileDataSource: this.initializeDataSource(),
    };
  }

  getGridData() {
    return this.state.tileDataSource;
  }

  getMoves() {
    return this.moves;
  }

  reset() {
    this.setState({tileDataSource: this.initializeDataSource()});
  }

  render() {
    return (
      <View
        style={{
          position: 'relative',
          alignItems: 'center',
          justifyContent: 'center',
          width: this.props.size * this.props.columns,
          height: this.props.size * this.props.rows,
          flexDirection: 'row',
          flexWrap: 'wrap'}}>
        <CardsView
          tilesData={this.state.tileDataSource}
          size={this.props.size}
          rows={this.props.rows}
          columns={this.props.columns}
          imageUrl={this.props.imageUrl}
          onChange={this.onCardChange}
        />
      </View>
    );
  }

  onCardChange = (cardId) => {
    if (this.props.noActionMode) {
      this.props.onActionClickedInNoActionMode();
      return;
    }

    const cardIndex = this.getIndexOf(cardId);
    const emptyIndex = this.getIndexOf(this.props.rows * this.props.columns - 1);

    let canMove = false;
    const {ski: indexI, skj: indexJ} = this.getIJ(cardIndex);
    const {ski: emptyI, skj: emptyJ} = this.getIJ(emptyIndex);
    if (((indexI + 1 === emptyI || indexI - 1 === emptyI) && indexJ === emptyJ)
      || ((indexJ + 1 === emptyJ || indexJ - 1 === emptyJ) && indexI === emptyI)) {
      canMove = true;
    }
    if (!canMove) {
      return;
    }

    const newTileDataSource = this.state.tileDataSource.slice();
    const newLoc = newTileDataSource[emptyIndex].location;
    newTileDataSource[emptyIndex].location = newTileDataSource[cardIndex].location;
    newTileDataSource[cardIndex].location = newLoc;
    const newMove = newTileDataSource[emptyIndex];
    newTileDataSource[emptyIndex] = newTileDataSource[cardIndex];
    newTileDataSource[cardIndex] = newMove;
    // TODO: set location using animation

    const selectedKeys = [];
    newTileDataSource.forEach((data) => {
      selectedKeys.push(data.cardId);
    });
    if (this.props.onChange) {
      this.props.onChange(selectedKeys);
    }
    logDebug('newTileDataSource', newTileDataSource);
    this.setState({tileDataSource: newTileDataSource});
  }

  getIndexOf(cardId) {
    for (let i = 0; i < this.state.tileDataSource.length; i++) {
      if (this.state.tileDataSource[i].cardId === cardId) {
        return i;
      }
    }
  }

  initializeDataSource() {
    // let cardIds = [0,1,2,3,4,5,6,7,8];
    let cardIds = [];
    for (let i = 0; i < this.props.rows; i++) {
      for (let j = 0; j < this.props.columns; j++) {
        cardIds.push(i * this.props.columns + j);
      }
    }
    if (!this.props.won) {
      const puzzle = flattenTo2DArray(cardIds, this.props.columns);
      const counter = 40 + Math.floor(Math.random() * 100) % (this.props.simulation ? 30 : 50);
      const scrambledData = this.generateScrambledPuzzle(puzzle, this.props.rows, this.props.columns, counter);
      cardIds = scrambledData.puzzle.flat();
      this.moves = scrambledData.moves;
    }

    return cardIds.map((cardId, index) => {
      const {ski: row, skj: column} = this.getIJ(index);
      const {ski: pRow, skj: pColumn} = this.getIJ(cardId);
      const locationXY = {x: this.props.size * column, y : this.props.size * row};
      const pieceLocationXY = {x: this.props.size * pColumn, y : this.props.size * pRow};
      return new TileData(cardId, locationXY, pieceLocationXY);
    });
  }

  generateScrambledPuzzle(puzzle, rows, columns, movesCount) {
    const totalTiles = rows * columns;
    const hiddenValue = totalTiles - 1; // Last tile is hidden

    let emptyPos = { i: Math.floor(hiddenValue / columns), j: hiddenValue % columns };
    let moves = [];
    const directions = [{ di: 1, dj: 0 }, { di: -1, dj: 0 }, { di: 0, dj: 1 }, { di: 0, dj: -1 }];

    for (let k = 0; k < movesCount; k++) {
      let validMoves = directions
        .map(({ di, dj }) => ({ i: emptyPos.i + di, j: emptyPos.j + dj }))
        .filter(({ i, j }) => i >= 0 && i < rows && j >= 0 && j < columns);

      let { i, j } = validMoves[Math.floor(Math.random() * validMoves.length)];
      moves.push({ movedTile: puzzle[i][j], swappedWith: puzzle[emptyPos.i][emptyPos.j] });

      [puzzle[emptyPos.i][emptyPos.j], puzzle[i][j]] = [puzzle[i][j], puzzle[emptyPos.i][emptyPos.j]];
      emptyPos = { i, j };
    }

    return { puzzle, moves };
  }

  getIJ(cardId) {
    const ski = parseInt(cardId / this.props.rows);
    const skj = cardId % this.props.columns;
    return {ski, skj};
  }
}

class TileData {

  constructor(cardId, locationXY, pieceLocationXY) {
    this.cardId = cardId;
    this.location = locationXY;
    this.pieceLocation = pieceLocationXY;
  }
}

const CardsView = React.memo((props) => {
  const {tilesData, size, rows, columns, imageUrl, onChange} = props;

  let tiles = [];
  tilesData.forEach((data) => {
    tiles.push(
      <CardView
        cardId={data.cardId}
        location={data.location}
        pLocation={data.pieceLocation}
        size={size}
        rows={rows}
        columns={columns}
        imageUrl={imageUrl}
        onChange={onChange}
      />
    );
  });
  return tiles;
});

const CardView = React.memo((props) => {
  const {cardId, location, pLocation, size, rows, columns, imageUrl, onChange} = props;

  const onChangeL = () => {
    onChange(cardId);
  };

  // const getIJ = (key) => {
  //   const ski = parseInt(key / rows);
  //   const skj = key % columns;
  //   return {ski, skj};
  // }
  // const {ski, skj} = getIJ(column.selectedKey);
  // logDebug('Card', {key: cardId, locX: pLocation.x, locY: pLocation.y});

  return (
    <View key={cardId} style={{position: 'absolute', left: location.x, top: location.y, overflow: 'hidden', width: size, height: size, padding: 1}}>
      <View style={{position: 'relative', overflow: 'hidden', width: size - 2, height: size - 2}}>
        {rows * columns - 1 !== cardId ?
          <TouchableOpacity onClick={onChangeL} style={{display: 'flex', flexDirection: 'row'}}>
            <AppImage
              resizeMode={'contain'}
              style={{
                position: 'absolute',
                left: -pLocation.x,
                top: -pLocation.y,
                width: size * rows,
                height: size * columns,
                // marginLeft: -pLocation.x,
                // marginTop: -pLocation.y,
              }}
              imageUrl={imageUrl}
            />
          </TouchableOpacity>
          : null
        }
      </View>
    </View>
  );
});
